import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import AdvancedPaymentsListView from 'src/sections/advanced-payments/view/advanced-payments-list-view';

export default function AdvancedPaymentsListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Advanced Payments </title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_ADVANCED_PAYMENT,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <AdvancedPaymentsListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
